import {compose} from "redux"
import {Router, withRouter} from "next/router"

// Page component
import SignUpPage from "../src/modules/authorization/pages/SignUpPage"

// HOCs
import withSignUp, {WithSignUpProps} from "../src/modules/authorization/hoc/withSignUp"
import withAuthProtection from "../src/hoc/withAuthProtection"
import withDeviceTypeRedirect from "../src/hoc/withDeviceTypeRedirect"

export type SignUpPageProps = {
    className?: string
    router: Router
} & WithSignUpProps

export default compose(
    withDeviceTypeRedirect,
    withAuthProtection,
    withRouter,
    withSignUp,
)(SignUpPage)
